/** @import { ShoreExcursion } from '../../types/shore-excursion' */

import { codify } from '@/utils/analytics';
import { unescapeHtml } from '@/utils/html';
import { memo } from 'react';
import { getItineraryTrackingAttributes } from '../../utils/analytics';
import classes from './excursion.module.css';

export const Excursion = memo(
  /**
   * @param  {object} props
   * @param {string} props.dayName
   * @param {ShoreExcursion} props.excursion
   * @returns {React.JSX.Element}
   */
  function ({ dayName, excursion }) {
    const itineraryTrackingAttributes = getItineraryTrackingAttributes();
    const name = unescapeHtml(excursion.name);
    const description = unescapeHtml(excursion.description);

    return (
      <div
        tl-event_name="shore_excursion_view"
        tl-itinerary_day_name={codify(dayName)}
        tl-excursion_name={codify(name)}
        {...itineraryTrackingAttributes}
        className={`${classes.excursion} track-attributes`}
      >
        <div className={classes.image}>
          <img src={excursion.image.url} loading="lazy" alt={excursion.image.caption ?? ''} />
        </div>
        <div className={classes.detail}>
          <h1 className={classes.title}>{name}</h1>
          <p className={classes.description}>{description}</p>
        </div>
      </div>
    );
  }
);
